<template>
  <ClientOnly>
    <RevDialog :name="modalName" :title="i18n(translations.title)">
      <template #body>
        <p class="text-static-default-low body-1 mb-6 mt-6">
          {{ i18n(translations.description) }}
        </p>
      </template>
      <template #footer>
        <div class="flex flex-col">
          <RevButton variant="primary" @click="openAddresses">
            {{ i18n(translations.openAddresses) }}
          </RevButton>

          <RevButton class="mb-8 mt-12" variant="secondary" @click="close">
            {{ i18n(translations.close) }}
          </RevButton>
        </div>
      </template>
    </RevDialog>
  </ClientOnly>
</template>

<script setup lang="ts">
import { navigateTo, useAsyncData } from '#imports'
import { onMounted } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { getBrowserCookie } from '@backmarket/utils/cookies/getBrowserCookie'
import { setBrowserCookie } from '@backmarket/utils/cookies/setBrowserCookie'
import { RevButton } from '@ds/components/Button'
import { RevDialog } from '@ds/components/Dialog'
import { closeModal, openModal } from '@ds/components/ModalBase'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './MissingReturnAddressModal.translations'

const modalName = 'missing-address-modal'
const MODAL_COOKIE_NAME = 'BM_savplatform-missing-return-addresses-alert'

const i18n = useI18n()
const $httpFetch = useHttpFetch()

const { data: sellerInformation } = await useAsyncData(() =>
  $httpFetch('/bm/customer_request/merchant/information'),
)

onMounted(() => {
  const modalCookie = getBrowserCookie(MODAL_COOKIE_NAME)

  if (sellerInformation.value?.returnAddresses.length === 0 && !modalCookie) {
    openModal(modalName)
  }
})

function close() {
  closeModal(modalName)

  const oneDay = 3600 * 24
  setBrowserCookie(MODAL_COOKIE_NAME, 'true', {
    maxAge: oneDay,
  })
}

function openAddresses() {
  close()

  navigateTo({
    name: ROUTE_NAMES.OPTIONS.ADDRESSES,
  })
}
</script>
